<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2">
      {{textBefore}} {{getValueArray(property)}} {{textAfter}}
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowArrayValueField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    textBefore: {
      type: String,
      default: ''
    },
    textAfter: {
      type: String,
      default: ''
    }
  },

  computed: {
    getValueArray () {
      return property => this.object? ((this.object[property] && this.object[property].length) ? this.object[property].map(el => el.tostring).join(', ') : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowArrayValueField.vue